var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurchaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.16667 1.99996C5.32405 1.79012 5.57104 1.66663 5.83334 1.66663H14.1667C14.429 1.66663 14.676 1.79012 14.8333 1.99996L17.3333 5.33329C17.5227 5.58581 17.5532 5.92365 17.412 6.20597C17.2709 6.48829 16.9823 6.66663 16.6667 6.66663H3.33334C3.01769 6.66663 2.72914 6.48829 2.58798 6.20597C2.44682 5.92365 2.47729 5.58581 2.66667 5.33329L5.16667 1.99996ZM6.25 3.33329L5 4.99996H15L13.75 3.33329H6.25Z",
    fill: "#4F5E71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 5.83329C2.5 5.37306 2.8731 4.99996 3.33333 4.99996H16.6667C17.1269 4.99996 17.5 5.37306 17.5 5.83329V16.6666C17.5 17.5871 16.7538 18.3333 15.8333 18.3333H4.16667C3.24619 18.3333 2.5 17.5871 2.5 16.6666V5.83329ZM4.16667 6.66663V16.6666H15.8333V6.66663H4.16667Z",
    fill: "#4F5E71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.08333 8.33329C7.54357 8.33329 7.91667 8.70639 7.91667 9.16663C7.91667 10.3172 8.84941 11.25 10 11.25C11.1506 11.25 12.0833 10.3172 12.0833 9.16663C12.0833 8.70639 12.4564 8.33329 12.9167 8.33329C13.3769 8.33329 13.75 8.70639 13.75 9.16663C13.75 11.2377 12.0711 12.9166 10 12.9166C7.92893 12.9166 6.25 11.2377 6.25 9.16663C6.25 8.70639 6.6231 8.33329 7.08333 8.33329Z",
    fill: "#4F5E71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseIcon);
export default __webpack_public_path__ + "static/media/purchase-icon.abfd383b2490b322f31be29873a429f3.svg";
export { ForwardRef as ReactComponent };